module.exports = __webpack_public_path__ + "static/img/c82dcae.png";


//////////////////
// WEBPACK FOOTER
// ./src/page/openAccount/images/logo.png
// module id = 256
// module chunks = 2